module.exports = __webpack_public_path__ + "static/media/teamAdmin_Zhang.95f72bc8.svg";